import React from 'react';
import { TextField } from './TextField';
export const Datepicker = (props) => (React.createElement(TextField, Object.assign({ type: 'date' }, props)));
Datepicker.displayName = 'Datepicker';
export default Datepicker;
